import { jsxs as g, jsx as e, Fragment as u } from "react/jsx-runtime";
import { memo as v, useMemo as b } from "react";
import { s as p } from "../../../chunks/useDataId.DKV4xcZ3.js";
import { e as f } from "../../../chunks/useDataAnalytics.aoO050RE.js";
import "../../../chunks/utils.BA8Gszn5.js";
import { v as N } from "../../../chunks/usePresentationClassWithSelectors.tBtkTeh8.js";
import { ICON_NAME as m } from "../../constants.js";
import '../../../styles/DIcon2.css';const _ = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", "data-qa": "image-arrow-circle", viewBox: "0 0 18 18", width: "16px", height: "16px", className: "dfa-svg", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.75 0a8.75 8.75 0 1 1 0 17.5 8.75 8.75 0 0 1 0-17.5m0 1.5a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5m1.497 3.75 3.503 3.495-3.505 3.505H7.873l2.661-2.662H3.75V7.91l6.784-.001-2.66-2.659z", className: "image-arrow_svg__image-fill" })
] }), y = /* @__PURE__ */ v(_), I = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-box", viewBox: "0 0 16 16", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "M1.25 1.25v13.5h13.5V1.25zM0 0h16v16H0z", className: "image-box_svg__image-fill" })
] }), q = /* @__PURE__ */ v(I), z = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", "data-qa": "image-caret-left", viewBox: "0 0 24 24", width: "16px", height: "16px", className: "dfa-svg", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "M18 19.65 10.583 12 18 4.35 15.717 2 6 12l9.717 10z" })
] }), $ = /* @__PURE__ */ v(z), M = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", "data-qa": "image-caret-right", viewBox: "0 0 24 24", width: "16px", height: "16px", className: "dfa-svg", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "M6 19.65 13.417 12 6 4.35 8.283 2 18 12 8.283 22z" })
] }), H = /* @__PURE__ */ v(M), B = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-chart", viewBox: "0 0 16 16", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", fillRule: "evenodd", d: "M4.5 0H7v16H4.5zm9 7H16v9h-2.5zM9 4h2.5v12H9zm-9 6h2.5v6H0z", className: "image-chart_svg__image-fill" })
] }), V = /* @__PURE__ */ v(B), C = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", className: "dfa-svg", "data-qa": "image-check-gray", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "#6E787F", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e("path", { fill: "#FFF", d: "M5 15v-3l4 4L20 5v3L9 19z" })
] }), k = /* @__PURE__ */ v(C), A = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", className: "dfa-svg", "data-qa": "checkbox-checked", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "#333f48", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e("path", { fill: "#FFF", d: "M5 15v-3l4 4L20 5v3L9 19z" })
] }), R = /* @__PURE__ */ v(A), F = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", className: "dfa-svg", "data-qa": "checkbox-unchecked", viewBox: "0 0 16 16", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "#333f48", d: "M1.25 1.25v13.5h13.5V1.25zM0 0h16v16H0z" })
] }), E = /* @__PURE__ */ v(F), S = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", "data-qa": "image-check-clear", viewBox: "0 0 24 24", width: "16px", height: "16px", className: "dfa-svg", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "m9.843 14.53-2.78-2.78-.947.94 3.727 3.726 8-8-.94-.94z" })
] }), j = /* @__PURE__ */ v(S), D = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-chevron-down", viewBox: "0 0 16 16", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 4.542 8.021 9.49 3 4.5v2.256l5.021 4.994L13 6.798z", className: "image-chevron-down_svg__image-fill" })
] }), P = /* @__PURE__ */ v(D), W = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-chevron-left", viewBox: "0 0 18 18", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "M4.5 15.5 11 9 4.5 2.5H7L13.5 9 7 15.5z", className: "image-chevron-left_svg__image-fill" })
] }), O = /* @__PURE__ */ v(W), Q = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-chevron-right", viewBox: "0 0 18 18", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "M4.5 15.5 11 9 4.5 2.5H7L13.5 9 7 15.5z", className: "image-chevron-right_svg__image-fill" })
] }), T = /* @__PURE__ */ v(Q), U = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-copy", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ g("g", { fill: "currentColor", fillRule: "evenodd", children: [
    /* @__PURE__ */ e("path", { d: "M15.634 2 20 6.367V17.25H7.75V2zm-.517 1.25H9V16h9.75V6.884z", className: "image-copy_svg__image-fill" }),
    /* @__PURE__ */ e("path", { d: "M15.107 2.442v4.213h4.268v1.25h-5.518V2.443zM8.375 7v1.228H5.25v11.544h9.5v-3.316H16V21H4V7z", className: "image-copy_svg__image-fill" })
  ] })
] }), X = /* @__PURE__ */ v(U), G = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", "data-qa": "image-close", viewBox: "0 0 24 24", width: "16px", height: "16px", className: "dfa-svg", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })
] }), J = /* @__PURE__ */ v(G), K = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-download-sheet", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "m16 1 5 5.238V23H4V1zm-1 1.75H5.75v18.5h13.498V7H15zm1.43 15.333 1.475 1.481H6.926l1.481-1.481zM13.159 6v8.065L17 10.222v2.094l-4.56 4.56L8 12.439v-2.095l3.676 3.676V6h1.482z", className: "image-download-sheet_svg__image-fill" })
] }), Y = /* @__PURE__ */ v(K), Z = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-download", viewBox: "0 0 20 23", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "M10 15v2.12l-6.5-6.499-1-1V7L9 13.5V0h2v13.5L17.5 7v2.621l-1 1L10 17.12zm-8.022 6h16.044L20 23H0z", className: "image-download_svg__image-fill" })
] }), L = /* @__PURE__ */ v(Z), ee = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-drag-handle", viewBox: "0 0 10 16", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("circle", { cx: 2, cy: 2, r: 1.5 }),
  /* @__PURE__ */ e("circle", { cx: 8, cy: 2, r: 1.5 }),
  /* @__PURE__ */ e("circle", { cx: 2, cy: 8, r: 1.5 }),
  /* @__PURE__ */ e("circle", { cx: 8, cy: 8, r: 1.5 }),
  /* @__PURE__ */ e("circle", { cx: 2, cy: 14, r: 1.5 }),
  /* @__PURE__ */ e("circle", { cx: 8, cy: 14, r: 1.5 })
] }), ae = /* @__PURE__ */ v(ee), le = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-pencil", viewBox: "0 2 22 21", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ g("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ e("path", { d: "M0 0h24v24H0z" }),
    /* @__PURE__ */ e("path", { fill: "currentColor", d: "M4 16.664v3.334h3.333l9.836-9.836-3.333-3.333zM19.738 6.336 17.662 4.26a.89.89 0 0 0-1.258 0l-1.626 1.627L18.11 9.22l1.627-1.627a.89.89 0 0 0 0-1.257z" })
  ] })
] }), w = /* @__PURE__ */ v(le), de = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-empty-circle", viewBox: "0 0 16 16", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("circle", { cx: 5, cy: 5, r: 4, fill: "none", stroke: "currentColor", strokeWidth: 2, transform: "translate(3 3)" })
] }), se = /* @__PURE__ */ v(de), ce = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-expand", viewBox: "0 0 14 14", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "M7.625 6.375H12v1.25H7.625V12h-1.25V7.625H2v-1.25h4.375V2h1.25z", className: "image-expand_svg__image-fill" })
] }), ie = /* @__PURE__ */ v(ce), te = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", stroke: "currentColor", className: "dfa-svg", "data-qa": "image-filters-toggle", viewBox: "0 0 17 18", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { strokeWidth: 1.75, d: "M0 2.5h17m-17 7h17m-17 6h17" }),
  /* @__PURE__ */ e("circle", { cx: 11.05, cy: 2.5, r: 2, fillRule: "evenodd" }),
  /* @__PURE__ */ e("circle", { cx: 4.76, cy: 9.5, r: 2, fillRule: "evenodd" }),
  /* @__PURE__ */ e("circle", { cx: 12.24, cy: 15.5, r: 2, fillRule: "evenodd" })
] }), re = /* @__PURE__ */ v(te), he = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-incomplete", viewBox: "0 0 20 20", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "m10.01 10.084 8.199-5.788C16.399 1.696 13.403 0 10.009 0 4.483 0 0 4.513 0 10.084c0 4.488 2.913 8.296 6.939 9.604zm-.938 8.765a8 8 0 0 1-.705-.092c-.284-.05-.551.164-.6.476-.045.314.15.611.431.661q.394.07.791.103l.043.003c.27-.003.499-.23.519-.534.022-.311-.192-.592-.479-.617m2.806-.081c-.227.06-.462.112-.694.154a.54.54 0 0 0-.43.625.53.53 0 0 0 .607.445q.394-.069.783-.173a.545.545 0 0 0 .376-.661.526.526 0 0 0-.642-.39M18.621 6.28c-.32.101-.49.417-.377.706q.14.356.244.72c.07.252.323.418.6.418q.075 0 .15-.016c.33-.078.53-.38.443-.677a9 9 0 0 0-.273-.812c-.116-.289-.466-.439-.787-.34M19 12.53c-.308-.1-.648.06-.75.351q-.13.361-.29.71a.55.55 0 0 0 .306.738.6.6 0 0 0 .24.046.6.6 0 0 0 .542-.338q.18-.393.326-.8c.102-.288-.063-.607-.374-.707m-4.337 4.752a10 10 0 0 1-.644.398.58.58 0 0 0-.219.774c.102.189.291.296.489.296a.53.53 0 0 0 .262-.069q.368-.21.723-.447a.58.58 0 0 0 .158-.79.547.547 0 0 0-.77-.162m4.754-7.907c-.325.003-.583.247-.58.543v.018a8 8 0 0 1-.028.732c-.026.299.216.556.533.58l.048.002c.297-.003.552-.216.577-.496q.034-.409.034-.82V9.91c-.003-.296-.264-.535-.584-.535m-1.705 5.75c-.224-.203-.543-.154-.715.111q-.212.324-.444.629a.684.684 0 0 0 .032.853.456.456 0 0 0 .721-.041q.262-.34.501-.704a.7.7 0 0 0 .1-.449.63.63 0 0 0-.195-.398", className: "image-incomplete_svg__image-fill" })
] }), ne = /* @__PURE__ */ v(he), ge = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-info-circle", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "#C7CCCE", fillRule: "evenodd", d: "M12 6a6 6 0 1 1 0 12 6 6 0 0 1 0-12m1 5h-2v5.143h2zm-1.017-3.286c-.734 0-1.269.568-1.269 1.203 0 .634.535 1.202 1.27 1.202.734 0 1.302-.518 1.302-1.202 0-.685-.568-1.203-1.303-1.203" })
] }), me = /* @__PURE__ */ v(ge), ve = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-kebab", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "M12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" })
] }), we = /* @__PURE__ */ v(ve), oe = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-leaf", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "M19 4.89S9.45 5 6 8.87s-1.53 7-.29 8.35 5.09 3.44 7.63 0S14.79 8.69 19 4.89", className: "image-leaf_svg__image-fill" }),
  /* @__PURE__ */ e("path", { d: "M11.22 11.77a12.31 12.31 0 0 0-5.85 9.93", className: "image-leaf_svg__image-fill-secondary" })
] }), xe = /* @__PURE__ */ v(oe), ue = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-little-i", viewBox: "0 0 30 30", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "currentColor", fillRule: "evenodd", d: "M15 26.25c6.213 0 11.25-5.037 11.25-11.25S21.213 3.75 15 3.75 3.75 8.787 3.75 15 8.787 26.25 15 26.25m0 1.25c6.904 0 12.5-5.596 12.5-12.5S21.904 2.5 15 2.5 2.5 8.096 2.5 15 8.096 27.5 15 27.5", clipRule: "evenodd" }),
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "M15.011 11.853c-.945 0-1.557-.595-1.557-1.453 0-.857.63-1.523 1.557-1.523.945 0 1.575.63 1.575 1.47 0 .858-.647 1.505-1.575 1.505m-2.485 9.397v-1.453h1.33v-5.285h-1.33V13.06h3.885v6.737h1.33v1.453z" })
] }), be = /* @__PURE__ */ v(ue), pe = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-little-x", viewBox: "0 0 15 14", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "M3 12.959v-2.174L6.937 7 3 3.215V1.041l4.979 4.787L13 1v2.174L9.021 7 13 10.826V13L7.979 8.172z", className: "image-little-x_svg__image-fill" })
] }), fe = /* @__PURE__ */ v(pe), Ne = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-lock", viewBox: "0 0 18 18", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "M9 2.25a3.75 3.75 0 0 1 3.747 3.587L12.75 6v2.25h1.5V15H3.75V8.25h1.5V6a3.75 3.75 0 0 1 3.587-3.747zm0 1.5a2.25 2.25 0 0 0-2.246 2.118L6.75 6v2.25h4.5V6a2.25 2.25 0 0 0-2.118-2.246z", className: "image-lock_svg__image-fill" })
] }), _e = /* @__PURE__ */ v(Ne), ye = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-minus", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "M3.625 11v2h17v-2H5z", className: "image-minus_svg__image-fill" })
] }), Ie = /* @__PURE__ */ v(ye), qe = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-minus-circle-active", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "#c7ccce", fillRule: "evenodd", d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16m.75 7.25H7.526a.535.535 0 0 0-.525.54v.444c0 .29.231.516.525.516h8.949l.096-.008a.51.51 0 0 0 .43-.508v-.445l-.007-.085a.53.53 0 0 0-.519-.454h-3.723z" })
] }), ze = /* @__PURE__ */ v(qe), $e = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-minus-circle-inactive", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ g("g", { fillRule: "evenodd", children: [
    /* @__PURE__ */ e("path", { d: "M12 3.25a8.75 8.75 0 1 0 .001 17.501A8.75 8.75 0 0 0 12 3.25m0 1.5a7.25 7.25 0 1 1 0 14.5 7.25 7.25 0 0 1 0-14.5" }),
    /* @__PURE__ */ e("path", { d: "M17 12.234a.51.51 0 0 1-.43.508l-.095.008H7.526A.516.516 0 0 1 7 12.234v-.445c0-.29.232-.539.526-.539h8.949c.264 0 .478.202.519.454l.006.085z" })
  ] })
] }), Me = /* @__PURE__ */ v($e), He = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-no-charge-active", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fillRule: "evenodd", d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16m3.848 5.192c-1.768 0-3.056 1.16-3.056 2.976s1.288 2.976 3.056 2.976c.776 0 1.576-.312 2.048-.984l-1.04-.776c-.256.384-.664.608-1.168.608-.904 0-1.6-.768-1.6-1.824s.696-1.824 1.64-1.824c.464 0 .824.168 1.072.464l.96-.784c-.48-.616-1.28-.832-1.912-.832m-7.576.144H6.576V15h1.248v-4.032h.016L10.312 15h1.632V9.336h-1.248v3.936h-.016z" })
] }), Be = /* @__PURE__ */ v(He), Ve = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-no-charge-inactive", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fillRule: "evenodd", d: "M12 3.25a8.75 8.75 0 1 1-.001 17.501A8.75 8.75 0 0 1 12 3.25m0 1.5a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5m3.848 4.442c.632 0 1.432.216 1.912.832l-.96.784c-.248-.296-.608-.464-1.072-.464-.944 0-1.64.768-1.64 1.824s.696 1.824 1.6 1.824c.504 0 .912-.224 1.168-.608l1.04.776c-.472.672-1.272.984-2.048.984-1.768 0-3.056-1.16-3.056-2.976s1.288-2.976 3.056-2.976m-7.576.144 2.408 3.936h.016V9.336h1.248V15h-1.632L7.84 10.968h-.016V15H6.576V9.336z" })
] }), Ce = /* @__PURE__ */ v(Ve), ke = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", className: "dfa-svg", "data-qa": "image-partial-check", viewBox: "0 0 16 16", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "#6E787F", fillRule: "evenodd", d: "M0 0h16v16H0zm3.91 7H13l-.91 1.5H3z", className: "image-partial-check_svg__image-fill" })
] }), o = /* @__PURE__ */ v(ke), Ae = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-restricted-circle-active", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fillRule: "evenodd", d: "M17.657 6.343A8 8 0 1 1 6.342 17.657 8 8 0 0 1 17.657 6.343m-2.33 2.33a4.706 4.706 0 1 0-6.654 6.656 4.706 4.706 0 0 0 6.654-6.656m-.117 4.077a3.295 3.295 0 0 1-6.418 0zm-.88-3.08c.451.451.745 1 .879 1.58H8.79a3.295 3.295 0 0 1 5.539-1.58z", className: "image-partial-restricted-circle-active_svg__image-fill" })
] }), Re = /* @__PURE__ */ v(Ae), Fe = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-restricted-circle-inactive", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "M19.187 5.399A8.75 8.75 0 1 1 6.811 17.773 8.75 8.75 0 0 1 19.187 5.399m-1.06 1.06A7.25 7.25 0 1 0 7.873 16.713 7.25 7.25 0 0 0 18.127 6.459m-1.8 1.8a4.706 4.706 0 1 1-6.656 6.654 4.706 4.706 0 0 1 6.656-6.654m-.117 4.077-2.61-.001H9.79a3.295 3.295 0 0 0 6.418 0zm-.88-3.08a3.295 3.295 0 0 0-5.539 1.58l2.61-.001h1.2l2.608.001a3.27 3.27 0 0 0-.88-1.58", className: "image-partial-restricted-circle-inactive_svg__image-fill" })
] }), Ee = /* @__PURE__ */ v(Fe), Se = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-plus", viewBox: "0 0 15 14", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fillRule: "evenodd", d: "M9 0v5.5h5.5v3H9V14H6V8.5H.5v-3H6V0z", className: "image-plus_svg__image-fill" })
] }), je = /* @__PURE__ */ v(Se), De = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-restricted-active", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 3.295a4.706 4.706 0 1 0 .001 9.411A4.706 4.706 0 0 0 12 7.295m2.8 2.966a3.295 3.295 0 0 1-4.539 4.538zM12 8.705c.638 0 1.234.181 1.739.496L9.2 13.739a3.295 3.295 0 0 1 2.799-5.034z", className: "image-restricted-circle-active_svg__image-fill" })
] }), Pe = /* @__PURE__ */ v(De), We = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-restricted-inactive", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fillRule: "evenodd", d: "M12 3.25a8.75 8.75 0 1 1-.001 17.501A8.75 8.75 0 0 1 12 3.25m0 1.5a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5m0 2.545a4.706 4.706 0 1 1-.001 9.411A4.706 4.706 0 0 1 12 7.295m2.8 2.966-1.846 1.844-.848.848L10.26 14.8a3.295 3.295 0 0 0 4.538-4.538zM12 8.705a3.295 3.295 0 0 0-2.799 5.034l1.844-1.846.849-.849 1.845-1.843A3.27 3.27 0 0 0 12 8.705", className: "image-restricted-circle-inactive_svg__image-fill" })
] }), Oe = /* @__PURE__ */ v(We), Qe = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-search", viewBox: "-4 -4 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "#6E787F", d: "m11.94 10.263 5.782 5.781-1.415 1.414-5.692-5.692A6.4 6.4 0 0 1 6.5 13.263c-3.61 0-6.5-2.986-6.5-6.631S2.89 0 6.5 0 13 2.987 13 6.632a6.7 6.7 0 0 1-1.06 3.63zM6.5 11.368c2.465 0 4.5-2.103 4.5-4.736 0-2.634-2.035-4.737-4.5-4.737S2 3.998 2 6.632s2.035 4.736 4.5 4.736", className: "image-search_svg__image-fill" })
] }), Te = /* @__PURE__ */ v(Qe), Ue = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-star", viewBox: "-2 -2 16 16", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "m6 9.637-3.708 1.976L3 7.427 0 4.462l4.146-.611L6 .042l1.854 3.809 4.146.61-3 2.966.708 4.186z", className: "image-star_svg__image-fill" })
] }), Xe = /* @__PURE__ */ v(Ue), Ge = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-table", viewBox: "0 0 16 16", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("g", { fill: "#6E787F", fillRule: "evenodd", children: /* @__PURE__ */ e("path", { d: "M0 0h16v2.5H0zM0 4.5h7V7H0zM0 9h7v2.5H0zM9 4.5h7V7H9zM9 9h7v2.5H9zM0 13.5h7V16H0zM9 13.5h7V16H9z" }) })
] }), Je = /* @__PURE__ */ v(Ge), Ke = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-x-circle-active", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "M12 3.25a8.75 8.75 0 1 1-.001 17.501A8.75 8.75 0 0 1 12 3.25m0 1.5a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5m3.321 3.51.065.055.315.315c.182.182.2.458.055.663l-.062.073L13.061 12l2.633 2.635c.187.187.196.48.046.687l-.055.065-.315.315a.51.51 0 0 1-.663.055l-.073-.062L12 13.06l-2.634 2.635a.515.515 0 0 1-.736.007l-.315-.315a.536.536 0 0 1-.01-.752L10.939 12 8.306 9.367a.515.515 0 0 1-.007-.736l.315-.315a.536.536 0 0 1 .752-.01L12 10.939l2.634-2.632a.53.53 0 0 1 .687-.046z", className: "image-x-circle-active_svg__image-fill" })
] }), Ye = /* @__PURE__ */ v(Ke), Ze = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-x-circle-inactive", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16m3.321 4.26a.53.53 0 0 0-.687.046L12 10.938 9.366 8.306a.534.534 0 0 0-.752.01l-.315.314a.516.516 0 0 0 .007.736L10.939 12l-2.633 2.635a.534.534 0 0 0 .01.752l.314.315c.205.205.529.2.736-.007L12 13.06l2.634 2.635.073.062a.51.51 0 0 0 .663-.055l.315-.315.055-.065a.53.53 0 0 0-.046-.687L13.061 12l2.633-2.633.062-.073a.51.51 0 0 0-.055-.663l-.315-.315z", className: "image-x-circle-inactive_svg__image-fill" })
] }), Le = /* @__PURE__ */ v(Ze), ea = ({
  title: d,
  titleId: a,
  desc: s,
  descId: l,
  ...c
}) => /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", className: "dfa-svg", "data-qa": "image-x", viewBox: "0 0 24 24", width: "16px", height: "16px", "aria-labelledby": a, "aria-describedby": l, ...c, children: [
  s ? /* @__PURE__ */ e("desc", { id: l, children: s }) : null,
  d ? /* @__PURE__ */ e("title", { id: a, children: d }) : null,
  /* @__PURE__ */ e("path", { fill: "#6E787F", d: "M5.18 19.445v-2.898l5.046-5.047-5.048-5.047V3.555l6.383 6.382L18 3.5v2.899L12.898 11.5 18 16.601V19.5l-6.438-6.437-6.383 6.382z", className: "image-x_svg__image-fill" })
] }), aa = /* @__PURE__ */ v(ea), la = "_dIcon_119n5_25", da = "_sizesdefault_119n5_25", sa = "_sizesmd_119n5_25", ca = "_sizesxs_119n5_29", ia = "_sizessm_119n5_33", ta = "_sizeslg_119n5_37", ra = "_themesdefault_119n5_41", ha = "_themeslight_119n5_41", na = "_themesdark_119n5_47", ga = {
  dIcon: la,
  sizesdefault: da,
  sizesmd: sa,
  sizesxs: ca,
  sizessm: ia,
  sizeslg: ta,
  themesdefault: ra,
  themeslight: ha,
  themesdark: na
}, fa = v(
  ({
    analytics: d,
    ariaLabel: a,
    dataQA: s,
    icon: l,
    size: c = "default",
    theme: x = "default",
    title: i,
    description: t
  }) => {
    const r = p("d-icon", s, { suffix: l }), h = f(d), n = N({
      styles: ga,
      defaultClass: "dIcon",
      selectors: {
        size: { valueSelector: c },
        theme: { valueSelector: x }
      }
    });
    return b(() => {
      switch (l) {
        case m.arrow:
          return /* @__PURE__ */ e(
            y,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.box:
          return /* @__PURE__ */ e(
            q,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.caretLeft:
          return /* @__PURE__ */ e(
            $,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.caretRight:
          return /* @__PURE__ */ e(
            H,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.chart:
          return /* @__PURE__ */ e(
            V,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.check:
          return /* @__PURE__ */ e(
            k,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.checkClear:
          return /* @__PURE__ */ e(
            j,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.checkPartial:
          return /* @__PURE__ */ e(
            o,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.checkmarkChecked:
          return /* @__PURE__ */ e(
            R,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.checkmarkUnChecked:
          return /* @__PURE__ */ e(
            E,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.chevronDown:
          return /* @__PURE__ */ e(
            P,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.chevronLeft:
          return /* @__PURE__ */ e(
            O,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.chevronRight:
          return /* @__PURE__ */ e(
            T,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.close:
          return /* @__PURE__ */ e(
            J,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.copy:
          return /* @__PURE__ */ e(
            X,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.download:
          return /* @__PURE__ */ e(
            L,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.downloadSheet:
          return /* @__PURE__ */ e(
            Y,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.dragHandle:
          return /* @__PURE__ */ e(
            ae,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.editPencil:
          return /* @__PURE__ */ e(
            w,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.emptyCircle:
          return /* @__PURE__ */ e(
            se,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.expand:
          return /* @__PURE__ */ e(
            ie,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.filtersToggle:
          return /* @__PURE__ */ e(
            re,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.incomplete:
          return /* @__PURE__ */ e(
            ne,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.infoCircle:
          return /* @__PURE__ */ e(
            me,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.kebab:
          return /* @__PURE__ */ e(
            we,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.leaf:
          return /* @__PURE__ */ e(
            xe,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.littleI:
          return /* @__PURE__ */ e(
            be,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.littleX:
          return /* @__PURE__ */ e(
            fe,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.lock:
          return /* @__PURE__ */ e(
            _e,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.minusCircleActive:
          return /* @__PURE__ */ e(
            ze,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.minusCircleInActive:
          return /* @__PURE__ */ e(
            Me,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.noChargeActive:
          return /* @__PURE__ */ e(
            Be,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.noChargeInActive:
          return /* @__PURE__ */ e(
            Ce,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.partialCheck:
          return /* @__PURE__ */ e(
            o,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.pencil:
          return /* @__PURE__ */ e(
            w,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.plus:
          return /* @__PURE__ */ e(
            je,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.restrictedActive:
          return /* @__PURE__ */ e(
            Pe,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.restrictedInActive:
          return /* @__PURE__ */ e(
            Oe,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.restrictedCircleActive:
          return /* @__PURE__ */ e(
            Re,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.restrictedCircleInActive:
          return /* @__PURE__ */ e(
            Ee,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.search:
          return /* @__PURE__ */ e(
            Te,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.star:
          return /* @__PURE__ */ e(
            Xe,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.table:
          return /* @__PURE__ */ e(
            Je,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.x:
          return /* @__PURE__ */ e(
            aa,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.xCircleActive:
          return /* @__PURE__ */ e(
            Ye,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.xCircleInActive:
          return /* @__PURE__ */ e(
            Le,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        case m.minus:
          return /* @__PURE__ */ e(
            Ie,
            {
              "aria-label": a,
              className: n,
              "data-qa": r,
              desc: t,
              title: i,
              ...h
            }
          );
        default:
          return /* @__PURE__ */ e(u, {});
      }
    }, [a, r, t, l, h, n, i]);
  }
);
export {
  fa as default
};
//# sourceMappingURL=DIcon.js.map
